import { Component, Input, EventEmitter, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'form-checkbox',
  template: `
    <div class="form-group">
      <p-checkbox [formControl]="control" [binary]="true" (onChange)="selectedChange.emit($event)"
        [style]="{'margin-bottom': 'calc(0.375rem + 1px)'}"></p-checkbox>&nbsp;&nbsp;
      <label class="col-form-label font-weight-bold">{{label}}</label>
      &nbsp;
      <i class="fas fa-info-circle text-primary input-icon-right cursor-pointer" style="float: none;"
        pTooltip="{{labelInfo}}" *ngIf="labelInfo"></i>
    </div>
  `,
})
export class FormCheckboxComponent {
  @Input() control: AbstractControl;
  @Input() label: string;
  @Input() labelInfo: string;

  @Output() selectedChange: EventEmitter<any> = new EventEmitter();
}
